module.exports = __webpack_public_path__ + "img/avatar0.0455bd79.png";